import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel", "chevron", "options"];

  connect() {
    this.isOpen = false;
  }

  toggle() {
    this.isOpen = !this.isOpen;

    // Handle both panel and options targets for different views
    if (this.hasPanelTarget) {
      this.panelTarget.classList.toggle("hidden");
    }
    if (this.hasOptionsTarget) {
      this.optionsTarget.classList.toggle("hidden");
    }

    // Rotate chevron
    if (this.hasChevronTarget) {
      this.chevronTarget.style.transform = this.isOpen ? "rotate(180deg)" : "";
    }
  }
}
